<h3 class="title">Monthly Statement</h3>

<ng-container *ngIf="statements.length > 0; else noStatements">
  <form [formGroup]="statementForm" (ngSubmit)="getStatement()" (keydown.enter)="$event.preventDefault()" class="terra-error-style"
        *ngIf="{
        availableYears: availableYears$ | async,
        availableMonths: availableMonths$ | async
        } as context">

    <div class="controls">
      <!-- Year -->
      <div class="terra-form-field-wrapper">
        <label for="ddlYear" class="text-input-label">Year</label>
        <mat-form-field appearance="outline">
          <mat-select id="ddlYear" placeholder="Select" formControlName="year">
            <mat-option [value]="null">Select</mat-option>
            <mat-option *ngFor="let year of context.availableYears" [value]="year">
              {{year}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="statementForm.get('year').hasError('required')">Required</mat-error>
        </mat-form-field>
      </div>

      <!-- Month -->
      <div class="terra-form-field-wrapper">
        <label for="ddlMonth" class="text-input-label">Month</label>
        <mat-form-field appearance="outline">
          <mat-select id="ddlMonth" formControlName="month" [placeholder]="!!statementForm.get('year').value ? 'Select' : 'Select a year'">
            <mat-option [value]="null">Select</mat-option>
            <mat-option *ngFor="let month of context.availableMonths" [value]="month">
              {{getMonthName(+month)}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="statementForm.get('month').hasError('required')">Required</mat-error>
        </mat-form-field>
      </div>
    </div>

    <button type="submit" class="download-button" color="primary" mat-flat-button [disabled]="isDownloading$ | async">
      <terra-loader *ngIf="isDownloading$ | async"></terra-loader>
      Download Monthly Statement
    </button>
    <mat-error *ngIf="errorDownloading$ | async" class="server-error">An error has occurred, please try again or contact support</mat-error>
  </form>
</ng-container>

<ng-template #noStatements>
  <p>No statements available at the moment</p>
</ng-template>
